import React from "react";

class GradientSVG extends React.Component {
  render() {
    let { firstColor, secondColor, idCSS, rotation = 0 } = this.props;

    let gradientTransform = `rotate(${rotation})`;

    return (
      <svg style={{ height: 0 }}>
        <defs>
          <linearGradient id={idCSS} gradientTransform={gradientTransform}> 
            <stop offset="0%" stopColor={firstColor} />
            <stop offset="25%" stopColor={secondColor} />
            <stop offset="50%" stopColor={firstColor} />
            <stop offset="75%" stopColor={secondColor} />
            <stop offset="100%" stopColor={firstColor} />
          </linearGradient>
       </defs>
      </svg>
    );
  }
}

export default GradientSVG;
